import { SCHEMA_CONTEXT } from '@config/global';
import { IGetLandingPage, IModulesData } from '@interfaces/IPages';
import { IBreadcrumbProps } from '../../components/atoms/breadcrumbs/breadcrumbs';
import { format } from 'date-fns';

export const getProductSeoSchema = (
    modulesData: IModulesData,
    landingPageData: IGetLandingPage,
): any => {
    const reviews = modulesData?.ugcData;
    const title = landingPageData?.title;
    const subpage = landingPageData?.subpage;
    const cheapestPrice = modulesData?.cruiseSearchlandingpageCheapestPrice;
    const lowPrice = Number(((cheapestPrice?.items[0]?.sailings?.minPrice || 0) / 2).toFixed(0));
    const offerCount = modulesData?.cruiseSearchlandingpageOffer?.totalCount;
    const ratingValue = reviews?.aggregation?.data.attributes.overall;
    const reviewCount = reviews?.aggregation?.data.attributes.numRatings;

    const seoSchemaData = {
        '@context': SCHEMA_CONTEXT,
        '@type': 'Product',
        name: title,
    } as any;
    let lowPriceSeoSchema = {};
    let ratingValueSeoSchema = {};

    if (lowPrice) {
        lowPriceSeoSchema = {
            ...seoSchemaData,
            offers: {
                '@type': 'AggregateOffer',
                offerCount,
                lowPrice,
                priceCurrency: 'EUR', //@TODO Fetch the currency dynamically
            },
        } as any;
    }
    if (ratingValue && ratingValue > 0) {
        ratingValueSeoSchema = {
            ...seoSchemaData,
            aggregateRating: {
                "@type": "AggregateRating",
                ratingValue: (ratingValue / 2).toFixed(1),
                reviewCount: reviewCount
            }
        }
    }
    return { ...seoSchemaData, ...lowPriceSeoSchema, ...ratingValueSeoSchema };
};

type IGoogleEventSchemaParams = {
    title: string;
    earliestDeparture: string;
    latestArrival: string;
    region: string;
    url: string;
};

type IGoogleRatingSchemaParams = {
    title: string;
    ratingValue: number;
    reviewCount: number;
};

export const getGoogleRatingSchema = (eventData: IGoogleRatingSchemaParams) => {
    return {
        '@context': 'http://schema.org',
        '@type': 'Product',
        name: eventData.title,
        aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: (eventData.ratingValue / 2).toFixed(1),
            reviewCount: eventData.reviewCount
        }
    }
}

export const getGoogleEventSchema = (eventData: IGoogleEventSchemaParams) => {
    const formattedStartDate = format(
        new Date(eventData.earliestDeparture),
        'yyyy-MM-dd',
    );

    const formattedEndDate = format(
        new Date(eventData.latestArrival),
        'yyyy-MM-dd',
    );

    return {
        '@context': 'http://schema.org',
        '@type': 'Event',
        name: eventData.title,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        url: eventData.url,
        location: {
            '@type': 'Place',
            name: eventData.region
        }
    }
}

export const getBreadCrumbSeoSchema = (
    breadcrumbList: IBreadcrumbProps['paths'],
    hostUrl: string,
): any => {
    const formatBCList =
        breadcrumbList?.length &&
        breadcrumbList.map(({ url, title }: { title: string; url: string }, index: number) => {
            return {
                '@type': 'ListItem',
                position: index + 1,
                item: {
                    '@id': `${hostUrl}${url}`,
                    name: title,
                },
            };
        });

    if (formatBCList && formatBCList.length > 0) {
        return {
            '@context': 'http://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: formatBCList,
        } as any;
    }
    return null;
};
